import React from "react";
import { Link } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";
import { useAuth } from "../context/AuthContext.jsx";
import { absMediaUrl } from "../api/events.js";

function getInitials(name = "") {
  const parts = String(name).trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "U";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0] || ""}${parts[1][0] || ""}`.toUpperCase();
}

export default function OrganizerConsoleHeader({ organizerId: organizerIdProp = "" }) {
  const { user } = useAuth() || {};
  const profileName = user?.name || user?.phone || user?.mobile || "Profile";
  const organizerId = organizerIdProp || user?.organizerId || "";
  const profileLabel = organizerId || profileName;
  const avatarSrc =
    absMediaUrl(user?.avatar || user?.profileImage) || user?.avatar || user?.profileImage || "";
  const initials = getInitials(profileName);

  return (
    <header className="sticky top-0 z-40 border-b border-white/10 bg-slate-950/90 backdrop-blur">
      <div className="mx-auto flex h-14 max-w-7xl items-center justify-between gap-3 px-4 sm:px-6 lg:px-10">
        <Link to="/listyourshow/manage" className="flex items-center gap-2.5">
          <span className="grid h-8 w-8 place-items-center rounded-lg bg-gradient-to-br from-amber-400 to-orange-500 text-base font-black text-slate-950">
            S
          </span>
          <div className="leading-tight">
            <div className="text-[11px] font-black uppercase tracking-[0.18em] text-amber-400">ShowTimeBro</div>
            <div className="text-[10px] font-semibold text-white/60">Organiser console</div>
          </div>
        </Link>
        <div className="flex items-center gap-2 sm:gap-3">
          <Link
            to="/listyourshow"
            className="inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-bold text-white/80 transition hover:bg-white/10 hover:text-white"
          >
            <FiArrowLeft className="hidden sm:block" /> Landing
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-bold text-white/80 transition hover:bg-white/10 hover:text-white"
          >
            Public website
          </Link>
          <Link
            to="/profile"
            className="inline-flex max-w-[14rem] items-center gap-2 rounded-full border border-white/15 bg-white/10 py-1 pl-1 pr-3 text-white transition hover:bg-white/15"
            title={organizerId ? `${organizerId} · ${profileName}` : profileName}
          >
            {avatarSrc ? (
              <img src={avatarSrc} alt="" className="h-7 w-7 rounded-full object-cover" />
            ) : (
              <span className="grid h-7 w-7 place-items-center rounded-full bg-gradient-to-br from-amber-400 to-orange-500 text-[10px] font-black text-slate-950">
                {initials}
              </span>
            )}
            <span className="min-w-0 leading-tight">
              <span className="block truncate text-xs font-bold">{profileLabel}</span>
              {organizerId ? (
                <span className="block truncate text-[10px] font-medium text-white/55">{profileName}</span>
              ) : (
                <span className="block truncate text-[10px] font-medium text-white/55">Profile</span>
              )}
            </span>
          </Link>
        </div>
      </div>
    </header>
  );
}
